import styled from 'styled-components';

export const clsPrefix = 'ui-list-item';

export const listClasses = {
  wrapper: clsPrefix,
  content: `${clsPrefix}-content`,
} as const;

export const ListItemSC = styled.div`
  padding: 12px 0;
  display: flex;
  align-items: center;

  transition: all 0.2s;
  background: transparent;

  ${({ theme }) => theme.mappedTypography.overline.default};

  &:hover:not(.${`${listClasses.wrapper}-disabled`}).${`${listClasses.wrapper}-clickable`} {
    cursor: pointer;
    background: ${({ theme }) => theme.createOverlayColor('transparent', 'hover', 'light')};
  }

  &.${`${listClasses.wrapper}-disabled`} {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }

  .${listClasses.content} {
    flex: 1;
    padding-left: 24px;
    padding-right: 24px;

    &.${`${listClasses.content}-has-left`} {
      padding-left: 0px;
    }

    &.${`${listClasses.content}-has-right`} {
      padding-right: 0px;
    }
  }
`;

export const ListItemGroup = styled.div`
  ${ListItemSC} {
    border-bottom: 1px solid ${({ theme }) => theme.color.border.emphasis};
  }
`;
